import React from 'react';
import { Col } from 'antd';

import { TextComponent } from 'baseComponents/TextComponent';

import './tabContentWrapper.scss';

interface Props {
  tabTitle: string;
}

export const TabContentWrapper: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  return (
    <Col
      className='tab-content'
      lg={{ pull: 3, push: 3, span: 18 }}
      md={{ pull: 0, push: 0, span: 24 }}
    >
      <TextComponent text={props.tabTitle} type='title' center />
      <div className='tab-main-content-wrapper'>{props.children}</div>
    </Col>
  );
};
